import { combineReducers } from "redux";
import login from "../features/auth/Slice";

const auth = combineReducers({
  login: login,
});

export default auth;
